import { render, staticRenderFns } from "./PagesEditor.vue?vue&type=template&id=035fb6c7&scoped=true&"
import script from "./PagesEditor.vue?vue&type=script&lang=js&"
export * from "./PagesEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035fb6c7",
  null
  
)

export default component.exports